"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _styledComponents = require("styled-components");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var withCustomPaletteColor = function withCustomPaletteColor(WrappedComponent) {
  var CustomThemeProvider = function CustomThemeProvider(props) {
    if (props.color && !['inherit', 'primary', 'secondary', 'default'].includes(props.color)) {
      var theme = (0, _core.createMuiTheme)(_objectSpread({}, props.theme, {
        palette: _objectSpread({}, props.theme.palette, {
          primary: props.theme.palette[props.color]
        })
      }));
      return _react.default.createElement(_core.MuiThemeProvider, {
        theme: theme
      }, _react.default.createElement(WrappedComponent, Object.assign({}, props, {
        color: "primary"
      })));
    }

    return _react.default.createElement(WrappedComponent, props);
  };

  CustomThemeProvider.defaultProps = {
    color: undefined
  };
  return (0, _styledComponents.withTheme)(CustomThemeProvider);
};

var _default = withCustomPaletteColor;
exports.default = _default;